import { ThemeOptions } from "@mui/material";

/**
 * Lloyds (LBG) typography.
 *
 * Headlines use the brand serif "GT Ultra Median"; body copy uses the brand
 * sans "GT Ultra Standard". Both webfonts are declared via @font-face in the
 * Lloyds environment's public/index.html (served from /fonts). Noto Sans /
 * system fonts act as fallbacks until the brand fonts load.
 */
const headlineFont = ['"GT Ultra Median"', "Georgia", "serif"].join(",");

const typography: ThemeOptions["typography"] = {
  fontFamily: ['"GT Ultra Standard"', '"Noto Sans"', "Roboto", "sans-serif"].join(","),
  h1: {
    fontFamily: headlineFont,
    fontWeight: 700,
    letterSpacing: "-0.01562em",
  },
  h2: {
    fontFamily: headlineFont,
    fontWeight: 700,
    letterSpacing: "-0.00833em",
  },
  h3: {
    fontFamily: headlineFont,
    fontWeight: 700,
    letterSpacing: "0em",
  },
  h4: {
    fontFamily: headlineFont,
    fontWeight: 700,
    letterSpacing: "0.00735em",
  },
  h5: {
    fontFamily: headlineFont,
    fontWeight: 700,
    letterSpacing: "0em",
  },
  h6: {
    fontFamily: headlineFont,
    fontWeight: 700,
    letterSpacing: "0.0075em",
  },
  subtitle1: {
    fontWeight: 600,
    letterSpacing: "0.00938em",
  },
  subtitle2: {
    fontWeight: 600,
    letterSpacing: "0.00714em",
  },
  // The designs set body copy, form labels and list rows at 14px rather than
  // MUI's default 16px.
  body1: {
    fontSize: "0.875rem",
    fontWeight: 400,
    letterSpacing: "0.00938em",
  },
  body2: {
    fontSize: "0.8125rem",
    fontWeight: 400,
    letterSpacing: "0.01071em",
  },
  button: {
    fontWeight: 600,
    letterSpacing: "0.01071em",
    textTransform: "none",
  },
  caption: {
    fontWeight: 400,
    letterSpacing: "0.02857em",
  },
  overline: {
    fontWeight: 400,
    letterSpacing: "0.08333em",
    textTransform: "uppercase",
  },
};

export default typography;
